import { RouterModule, Routes } from '@angular/router';
import { ViewUserComponent } from './components/view-user/view-user.component';
import { ListUserComponent } from './components/list-user/list-user.component';
import { HomeUserComponent } from './components/home-user/home-user.component';



export const UserRouter: Routes = [
    { path: '', component: HomeUserComponent },
    { path: 'create', component: ViewUserComponent },
    { path: 'view/:id', component: ViewUserComponent },
    { path: 'list', component: ListUserComponent }
];


// WEBPACK FOOTER //
// ./src/app/user/user.router.ts